/* OUTEQ — mřížka kolekce: filtrování bez znovunačtení stránky, cenový posuvník,
 * rychlé přidání do košíku, mobilní drawer filtrů.
 *
 * Přesunuto z inline `<script>` v sekci do assetu ze stejného důvodu jako CSS:
 * odpověď na klik na filtr nesla i 17 kB tohoto skriptu.
 *
 * Hodnoty, které dřív dodával Liquid, se teď čtou z data atributů na uzlu
 * sekce (data-oq-cg): section-id, symbol měny a dva popisky tlačítka. Jinak by
 * je nebylo z assetu odkud vzít.
 *
 * Inicializace je jednorázová na uzel (data-oq-cg-init). Je to podstatné:
 * skript po výměně mřížky sám posílá `shopify:section:load` kvůli srdíčkům
 * oblíbených, a bez té pojistky by se na tu vlastní událost inicializoval
 * dokola.
 */
  function oqInitCollectionGrid(root) {
    if (!root || root.dataset.oqCgInit === '1') return;
    root.dataset.oqCgInit = '1';

    // Mobilní filtr-drawer: Filtrovat otevře, backdrop/křížek/Zobrazit produkty zavře
    var bar = root.querySelector('.outeq-cg__form');
    if (bar) {
      var setOpen = function (open) {
        bar.classList.toggle('is-filters-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      root.querySelectorAll('[data-cg-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
      root.querySelectorAll('[data-cg-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    }

    /* ── Filtrování bez znovunačtení stránky ────────────────────────────────
       Dřív každý filtr volal this.form.submit(), takže se načetla celá stránka
       znovu (hlavička, patička, všechny sekce) — bylo to pomalé a hlavně se tím
       zavřel rozbalený filtr, protože <details> se vykreslil od nuly.

       Teď se přes Section Rendering API dotahuje jen tato sekce a vyměňují se
       dva uzly: seznam filtrů (kvůli aktuálním počtům) a mřížka. Formulář ani
       lišta nad ním se nevyměňují, takže na mobilu zůstane otevřený panel
       filtrů a tlačítko „Filtrovat" si drží svůj listener.

       Stav rozbalení si pamatujeme podle data-facet-key a po výměně ho vrátíme
       — to je ta věc, která uživatele štvala nejvíc.

       Pozor: form.submit() NEspouští událost submit, takže odchytit submit
       nestačilo; inline onchange handlery jsou proto ze snippetu oq-cg-facet
       odstraněné a vstupy se navazují tady. */
    var SECTION_ID = root.dataset.sectionId || '';
    var cgMain = function () { return root.querySelector('.outeq-cg__main'); };
    var cgFacets = function () { return root.querySelector('.outeq-cg__facets'); };
    var cgForm = root.querySelector('.outeq-cg__form');
    var cgReq = 0;
    var cgAbort = null;

    /* Proč cache a předstahování: Shopify sekci připraví za ~21 ms
       (server-timing), ale komprimované tělo má ~11,6 kB a jeho přenos trvá
       125–350 ms. Celou tu dobu se na stránce nic neděje, takže klik na filtr
       působí jako prodleva, i když server je rychlý.

       Řešení: jak uživatel najede na volbu filtru, na pozadí se stáhne
       výsledek, který by ta volba dala. Klik pak jen prohodí DOM z paměti,
       bez čekání na síť. Výsledek závisí jen na URL, takže cachovat podle URL
       je bezpečné. */
    var cgCache = new Map();
    var CG_CACHE_MAX = 12;
    var cgPrefetching = 0;
    var cgHoverTimer = null;

    /* Klíč cache musí být nezávislý na POŘADÍ parametrů. Předstažená URL má
       novou hodnotu připojenou na konec, ale po skutečném zaškrtnutí se pořadí
       řídí pořadím vstupů v DOM (u krytí je IP44 před IP67). Bez srovnání by se
       klíče nesešly a předstažení by bylo k ničemu. */
    function cgKey(url) {
      var q = url.indexOf('?');
      if (q === -1) return url;
      var pairs = [];
      new URLSearchParams(url.slice(q + 1)).forEach(function (v, k) { pairs.push(k + '=' + v); });
      pairs.sort();
      return url.slice(0, q) + '?' + pairs.join('&');
    }

    function cgCachePut(url, html) {
      var k = cgKey(url);
      if (cgCache.has(k)) cgCache.delete(k);
      cgCache.set(k, html);
      while (cgCache.size > CG_CACHE_MAX) cgCache.delete(cgCache.keys().next().value);
    }

    function cgFetch(url) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(SECTION_ID))
        .then(function (r) {
          if (!r.ok) throw new Error('section render ' + r.status);
          return r.text();
        });
    }

    function cgPrefetch(url) {
      /* Jedno stahování na pozadí stačí — jinak by projetí myší po dlouhém
         seznamu filtrů vystřelilo desítku requestů naráz. */
      if (!url || cgCache.has(cgKey(url)) || cgPrefetching > 0) return;
      cgPrefetching++;
      cgFetch(url)
        .then(function (html) { cgCachePut(url, html); })
        .catch(function () { /* předstažení je bonus, chyba se ignoruje */ })
        .finally(function () { cgPrefetching--; });
    }

    /* URL, která by vznikla po přepnutí jednoho vstupu — bez toho, aby se
       skutečně přepnul. */
    function cgUrlWithToggled(input) {
      if (!cgForm) return null;
      var params = new URLSearchParams();
      new FormData(cgForm).forEach(function (v, k) {
        if (String(v).trim() !== '') params.append(k, v);
      });
      if (input.checked) {
        var keep = params.getAll(input.name).filter(function (v) { return v !== input.value; });
        params.delete(input.name);
        keep.forEach(function (v) { params.append(input.name, v); });
      } else {
        params.append(input.name, input.value);
      }
      var qs = params.toString();
      return location.pathname + (qs ? '?' + qs : '');
    }


    function bindOnce(el, ev, fn) {
      if (!el || el.dataset.oqBound === ev) return;
      el.dataset.oqBound = ev;
      el.addEventListener(ev, fn);
    }

    function openFacetKeys() {
      var keys = [];
      root.querySelectorAll('.outeq-cg__facet[open]').forEach(function (d) {
        if (d.dataset.facetKey) keys.push(d.dataset.facetKey);
      });
      return keys;
    }

    function restoreFacetKeys(keys) {
      root.querySelectorAll('.outeq-cg__facet').forEach(function (d) {
        d.open = keys.indexOf(d.dataset.facetKey) !== -1;
      });
    }

    function filterUrl() {
      if (!cgForm) return location.pathname;
      var params = new URLSearchParams();
      new FormData(cgForm).forEach(function (v, k) {
        if (String(v).trim() !== '') params.append(k, v);
      });
      var qs = params.toString();
      /* page se do FormData nedostane, takže se filtrováním vždy vracíme na
         první stranu — to je správně, na 4. straně by po zúžení nemuselo nic být. */
      return location.pathname + (qs ? '?' + qs : '');
    }

    function oqRender(url, opts) {
      opts = opts || {};
      var main = cgMain();
      /* Když je výsledek předstažený, výměna je hotová v řádu milisekund —
         ztmavení by jen bliklo. */
      if (main && !cgCache.has(cgKey(url))) main.classList.add('is-loading');
      var token = ++cgReq;
      if (cgAbort) cgAbort.abort();
      cgAbort = ('AbortController' in window) ? new AbortController() : null;

      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var cached = cgCache.get(cgKey(url));
      var source = cached
        ? Promise.resolve(cached)
        : fetch(url + sep + 'section_id=' + encodeURIComponent(SECTION_ID),
                cgAbort ? { signal: cgAbort.signal } : undefined)
            .then(function (r) {
              if (!r.ok) throw new Error('section render ' + r.status);
              return r.text();
            })
            .then(function (html) { cgCachePut(url, html); return html; });
      source
        .then(function (html) {
          if (token !== cgReq) return; // dorazila stará odpověď, zahodit
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var openKeys = openFacetKeys();

          var newFacets = doc.querySelector('.outeq-cg__facets');
          var oldFacets = cgFacets();
          if (newFacets && oldFacets) oldFacets.replaceWith(newFacets);

          var newMain = doc.querySelector('.outeq-cg__main');
          var oldMain = cgMain();
          if (newMain && oldMain) {
            if (!cached) newMain.classList.add('is-swapped');
            oldMain.replaceWith(newMain);
          }

          /* Lištu nevyměňujeme (drží listenery), jen přepíšeme obsah tlačítka
             s počtem aktivních filtrů. */
          var newToggle = doc.querySelector('.outeq-cg__filter-toggle');
          var oldToggle = root.querySelector('.outeq-cg__filter-toggle');
          if (newToggle && oldToggle) oldToggle.innerHTML = newToggle.innerHTML;

          var newForm = doc.querySelector('.outeq-cg__form');
          if (newForm && cgForm) {
            cgForm.classList.toggle('has-active-filters', newForm.classList.contains('has-active-filters'));
          }

          restoreFacetKeys(openKeys);
          initPriceSliders();
          initQuickAdd();
          initFilterInputs();
          initFacetCloseButtons();
          /* Shopify tuhle událost posílá na uzel sekce, ne na document — držíme
             se toho, aby si cizí skripty mohly sáhnout na event.target.
             Skript oblíbených ji odchytává na documentu, kam probublá. */
          root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: SECTION_ID } }));

          if (opts.push !== false) history.pushState({ oqCg: true }, '', url);
          if (opts.scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          /* Když se dotažení nepovede, ať uživatel neuvízne — dokončí se to
             klasickým načtením stránky. */
          window.location.href = url;
        })
        .finally(function () {
          var m = cgMain();
          if (m && token === cgReq) m.classList.remove('is-loading');
        });
    }

    function oqApplyFilters(opts) { oqRender(filterUrl(), opts); }

    function initFilterInputs() {
      var facets = cgFacets();
      if (!facets) return;
      /* DOSTUPNOST se chová jako přepínač, ne jako dvě nezávislá zaškrtávátka:
         „Všechno zboží" ↔ „Skladem". Políčko „Všechno zboží" nemá `name`, takže
         se do adresy filtru (staví se z FormData) nedostane — a právě žádný
         parametr dostupnosti znamená „ukaž všechno". Odškrtnout ho proto nejde:
         prázdný výběr JE všechno zboží, jen by pak nebylo nic zaškrtnuté. */
      var allBox = facets.querySelector('[data-cg-all]');
      var avBoxes = Array.prototype.slice.call(
        facets.querySelectorAll('.outeq-cg__opt input[name="filter.v.availability"]')
      );
      function syncAllBox() {
        if (!allBox) return;
        allBox.checked = !avBoxes.some(function (b) { return b.checked; });
      }
      if (allBox) {
        bindOnce(allBox, 'change', function () {
          allBox.checked = true;
          avBoxes.forEach(function (b) { b.checked = false; });
          if (!window.matchMedia('(max-width: 749px)').matches) oqApplyFilters();
        });
      }

      facets.querySelectorAll('.outeq-cg__opt input[type="checkbox"]').forEach(function (cb) {
        /* „Všechno zboží" má vlastní obsluhu výš a bez `name` by ho předstahování
           (cgUrlWithToggled staví adresu z name/value) jen rozbilo. */
        if (cb.hasAttribute('data-cg-all')) return;
        /* Na mobilu se čeká na „Zobrazit produkty", aby se panel nepřekresloval
           pod rukou při každém zaškrtnutí. */
        bindOnce(cb, 'change', function () {
          syncAllBox();
          if (!window.matchMedia('(max-width: 749px)').matches) oqApplyFilters();
        });
        /* Předstažení jen tam, kde je skutečný kurzor — na dotyku by to jen
           pálilo data, navíc tam klik stejně čeká na „Zobrazit produkty". */
        var opt = cb.closest('.outeq-cg__opt');
        if (opt && window.matchMedia('(pointer: fine)').matches) {
          bindOnce(opt, 'pointerenter', function () {
            clearTimeout(cgHoverTimer);
            /* Krátká prodleva, aby projetí myší přes seznam nespustilo stahování
               u každé volby, kterou kurzor jen přejede. */
            cgHoverTimer = setTimeout(function () { cgPrefetch(cgUrlWithToggled(cb)); }, 110);
          });
          bindOnce(opt, 'pointerleave', function () { clearTimeout(cgHoverTimer); });
        }
      });
      facets.querySelectorAll('.oq-price-num').forEach(function (inp) {
        bindOnce(inp, 'change', function () {
          if (!window.matchMedia('(max-width: 749px)').matches) oqApplyFilters();
        });
      });
      var main = cgMain();
      if (main) {
        main.querySelectorAll('.outeq-cg__pagination a').forEach(function (a) {
          if (window.matchMedia('(pointer: fine)').matches) {
            bindOnce(a, 'pointerenter', function () { cgPrefetch(a.getAttribute('href')); });
          }
          bindOnce(a, 'click', function (e) {
            /* Modifikátory a nová karta se nechávají prohlížeči. */
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
            e.preventDefault();
            oqRender(a.getAttribute('href'), { scroll: true });
          });
        });
      }
    }

    function initFacetCloseButtons() {
      var facets = cgFacets();
      if (!facets) return;
      facets.querySelectorAll('[data-cg-close]').forEach(function (b) {
        bindOnce(b, 'click', function () {
          cgForm && cgForm.classList.remove('is-filters-open');
          document.documentElement.style.overflow = '';
        });
      });
    }

    if (cgForm) {
      cgForm.addEventListener('submit', function (e) {
        e.preventDefault();
        /* Mobilní „Zobrazit produkty" panel zavře, ať je výsledek hned vidět. */
        var fromApply = e.submitter && e.submitter.classList.contains('outeq-cg__apply-btn');
        oqApplyFilters();
        if (fromApply) {
          cgForm.classList.remove('is-filters-open');
          document.documentElement.style.overflow = '';
        }
      });
    }

    window.addEventListener('popstate', function (ev) {
      if (!ev.state || !ev.state.oqCg) return;
      oqRender(location.pathname + location.search, { push: false });
    });

    // Řazení: nativní hodnoty = odeslat formulář (sort_by); „Dle % slevy" = client-side
    // seřazení mřížky sestupně dle data-discount (basis points). Kategorie jsou malé
    // (1 strana), takže client-side pokrývá vše.
    var sortSel = root.querySelector('[data-oq-sort]');
    if (sortSel) {
      var grid = root.querySelector('.outeq-cg__grid');
      var sortByDiscount = function () {
        if (!grid) return;
        Array.prototype.slice.call(grid.querySelectorAll('.outeq-bs-card'))
          .sort(function (a, b) { return (Number(b.dataset.discount) || 0) - (Number(a.dataset.discount) || 0); })
          .forEach(function (c) { grid.appendChild(c); });
      };
      sortSel.addEventListener('change', function () {
        if (this.value === 'discount') { sortByDiscount(); }
        else { oqApplyFilters(); }
      });
    }

    // Cenový dual-range posuvník (styl mobileorigin): sync s číselnými poli + výplň + Kč popisky
    function initPriceSliders() {
    root.querySelectorAll('.oq-price-slider').forEach(function (sl) {
      var panel = sl.closest('.outeq-cg__panel--price');
      var rMin = sl.querySelector('.oq-price-range--min');
      var rMax = sl.querySelector('.oq-price-range--max');
      var fill = sl.querySelector('.oq-price-fill');
      var nMin = panel.querySelector('.oq-price-num--min');
      var nMax = panel.querySelector('.oq-price-num--max');
      var lMin = panel.querySelector('.oq-price-lbl--min');
      var lMax = panel.querySelector('.oq-price-lbl--max');
      var CUR = root.dataset.currency || '';
      var lo = Number(sl.dataset.min) || 0;
      var hi = Number(sl.dataset.max) || 1;
      var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
      function pct(v) { return ((v - lo) / (hi - lo)) * 100; }
      function paint() {
        var a = Number(rMin.value), b = Number(rMax.value);
        if (a > b) { var t = a; a = b; b = t; }
        fill.style.left = pct(a) + '%';
        fill.style.right = (100 - pct(b)) + '%';
        /* Symbol měny se bere z aktivního trhu, ne natvrdo „Kč" — na slovenském
           a EU trhu jsou ceny v eurech a posuvník by u nich psal koruny.
           cart.currency.symbol je stejný zdroj, jaký používá snippet
           price-filter, takže se to nerozejde. */
        if (lMin) lMin.textContent = a + ' ' + CUR;
        if (lMax) lMax.textContent = b + ' ' + CUR;
      }
      rMin.addEventListener('input', function () {
        if (Number(rMin.value) > Number(rMax.value)) rMin.value = rMax.value;
        if (nMin) nMin.value = (Number(rMin.value) === lo) ? '' : rMin.value;
        paint();
      });
      rMax.addEventListener('input', function () {
        if (Number(rMax.value) < Number(rMin.value)) rMax.value = rMin.value;
        if (nMax) nMax.value = (Number(rMax.value) === hi) ? '' : rMax.value;
        paint();
      });
      // po puštění posuvníku: na desktopu rovnou odeslat (na mobilu čeká na „Zobrazit produkty")
      [rMin, rMax].forEach(function (r) {
        r.addEventListener('change', function () { if (!isMobile()) oqApplyFilters(); });
      });
      // číselná pole -> posuvník
      if (nMin) nMin.addEventListener('input', function () { rMin.value = nMin.value === '' ? lo : nMin.value; paint(); });
      if (nMax) nMax.addEventListener('input', function () { rMax.value = nMax.value === '' ? hi : nMax.value; paint(); });
      paint();
    });
    }

    function initQuickAdd() {
    root.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      var label = btn.querySelector('.outeq-bs-card__qa-label');
      var defaultText = label ? label.textContent.trim() : '';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.id, data: { source: 'quick-add', itemCount: cart.item_count } } }));
            btn.classList.add('is-added');
            if (label) label.textContent = root.dataset.addedText || defaultText;
          })
          .catch(function () { if (label) label.textContent = root.dataset.errorText || defaultText; })
          .finally(function () { setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = defaultText; btn.disabled = false; }, 2000); });
      });
    });
    }
    initPriceSliders();
    initQuickAdd();
    initFilterInputs();
    initFacetCloseButtons();
  }

  function oqInitAllCollectionGrids() {
    document.querySelectorAll('[data-oq-cg]').forEach(oqInitCollectionGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', oqInitAllCollectionGrids);
  } else {
    oqInitAllCollectionGrids();
  }
  /* V editoru tématu se sekce překresluje — nové uzly se doinicializují,
     už hotové projdou naprázdno díky data-oq-cg-init. */
  document.addEventListener('shopify:section:load', oqInitAllCollectionGrids);
